<template>
  <Modal :value="value" @hide="hide()" title="Add domain">
    <template slot="body" class="content">
      <div class="margin-bottom-1">
        <BInput
          v-model="domainName"
          type="text"
          validation="required"
          placeholder="New domain name"
          name="name"
          focus="true"
          @enter="save()"
        ></BInput>

        <div class="notification is-primary is-light">
          A domain is a workspace. The idea is to separate unrelated
          environments from each other.
        </div>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div
          @click="save()"
          :disabled="domainName == ''"
          class="button is-success"
        >
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
  },
  data() {
    return {
      domainName: "",
      isLoading: false,
    };
  },

  methods: {
    async save() {
      if (!this.loading && this.domainName) {
        this.isLoading = true;
        await this.$store.dispatch("domain/add", this.domainName.trim());
        this.isLoading = false;
        this.$emit("success");
        this.hide();
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
